var map = {
	"./auth-routes.js": 6509,
	"./complaint-routes.js": 9201,
	"./costumer-routes.js": 5127,
	"./general-routes.js": 5724,
	"./master-routes.js": 5966,
	"./transaction-routes.js": 6073,
	"./user-routes.js": 994
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 981;